var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTrashRed({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.66536 4.00016V2.00016C4.66536 1.82335 4.7356 1.65378 4.86063 1.52876C4.98565 1.40373 5.15522 1.3335 5.33203 1.3335H10.6654C10.8422 1.3335 11.0117 1.40373 11.1368 1.52876C11.2618 1.65378 11.332 1.82335 11.332 2.00016V4.00016H14.6654V5.3335H13.332V14.0002C13.332 14.177 13.2618 14.3465 13.1368 14.4716C13.0117 14.5966 12.8422 14.6668 12.6654 14.6668H3.33203C3.15522 14.6668 2.98565 14.5966 2.86063 14.4716C2.7356 14.3465 2.66536 14.177 2.66536 14.0002V5.3335H1.33203V4.00016H4.66536ZM8.94136 9.3335L10.12 8.15483L9.17736 7.21216L7.9987 8.39083L6.82003 7.21216L5.87736 8.15483L7.05603 9.3335L5.87736 10.5122L6.82003 11.4548L7.9987 10.2762L9.17736 11.4548L10.12 10.5122L8.94136 9.3335ZM5.9987 2.66683V4.00016H9.9987V2.66683H5.9987Z",
    fill: "#F15D5F"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTrashRed);
export default __webpack_public_path__ + "static/media/trashRed.0671bee60425b87dbc13dd4b4b9c1391.svg";
export { ForwardRef as ReactComponent };